var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fab-transition',[_c('v-btn',{staticClass:"fab",attrs:{"dark":"","fab":"","absolute":"","bottom":"","right":"","elevation":6,"color":_vm.color},on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }